import requester from '@/lib/axios';
import { AssessmentCriteria } from '@/models/Assessment';

const buildBaseUrl = (
  evaluationId: number,
  assessmentId: number,
  itemId: number,
) =>
  `evaluations/${evaluationId}/assessments/${assessmentId}/items/${itemId}/criteria`;

export const createAssessmentCriteria = async (
  evaluationId: number,
  assessmentId: number,
  itemId: number,
  body: Partial<AssessmentCriteria>,
) => {
  const { data } = await requester().post<AssessmentCriteria>(
    `${buildBaseUrl(evaluationId, assessmentId, itemId)}/`,
    body,
  );
  return data;
};

export const updateAssessmentCriteria = async (
  evaluationId: number,
  assessmentId: number,
  itemId: number,
  criteriaId: number,
  body: Partial<AssessmentCriteria>,
) => {
  const { data } = await requester().patch<AssessmentCriteria>(
    `${buildBaseUrl(evaluationId, assessmentId, itemId)}/${criteriaId}/`,
    body,
  );
  return data;
};

export const deleteAssessmentCriteria = async (
  evaluationId: number,
  assessmentId: number,
  itemId: number,
  criteriaId: number,
) => {
  await requester().delete<void>(
    `${buildBaseUrl(evaluationId, assessmentId, itemId)}/${criteriaId}/`,
  );
};
